import axios from 'axios'
import { getCookie, removeToken, setCookie } from '@/utils/auth'
// 根据环境不同引入不同api地址
import { baseApi, loginUrl } from '@/config'
import { Message } from 'modesign'
import { formatRequestUrl } from '@/utils/index'
import { nanoid } from 'nanoid'
import mockApis from '@/whiteMock.js'
import store from '@/store'
import { blobToObject, addPending, deletePending } from '@/utils/tools'
import showMessage from '@/utils/message'
import { Api } from '@/api'
import createFn from '@/utils/log'
import router from '@/router'
let loadingInstance = null
const submitLog = (e, response) => { 
  const api = response?.config?.url;
  //如果是收集错误日志的接口报错了，就不提交了，避免死循环
  if (api === '/api/zzp-control/tenant/saveProdLog') { 
    return;
  }
  const err = {
    message:`请求code是：${e.code}，错误内容是：${e.msg}`
  }
  const p = createFn(err, 1, {
    api,
    data:response?.config?.data
  });
  Api.saveProdLog(p)
}

const service = axios.create({
  baseURL: formatRequestUrl(baseApi), // url = base api url + request url 只要是发布环境的 一律为''阿
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 300000 // request timeout
})

// request拦截器 request interceptor
service.interceptors.request.use(
  config => {
    addPending(config)
    // console.log(config, 'config')
    // 不传递默认开启loading
    if (config.hideloading) {
      // loading
      loadingInstance = this.$loading({
        background: 'rgba(255, 255, 255, .8)',
        lock: true,
        text: '加载中...'
      })
    }
    if (getCookie('headers-token') && !getCookie('dhr-Token')) {
      config.headers['dhr-Token'] = getCookie('headers-token')
    }
    config.headers['traceId'] = nanoid()
    if (['pre'].includes(process.env.NODE_ENV)) {
      // config.headers['dhr-Token'] = 'vTW5D7LVHY3yxTuaqwrQaTBAQ8WwoEd2'
      // config.headers['dhr-Token'] = 'XaXm0Hmq0jSQEx9J1oQSH52GyMFNEFUo'
      // config.headers['dhr-Token'] = 'eUqdIrixp80swYAgit 5zinvSKmbbGGmyUCF'
      // config.headers['userId'] = '17699'
    }
    if (['uat'].includes(process.env.NODE_ENV)) {
      // config.headers['dhr-Token'] = 'rDP2x9PKUwrAJA1ebk7Ap6dfSfnpdY9C'
      // config.headers['dhr-Token'] = 'aO6dfGtZXVYSxFm80jva2faPw6VzOL3e'
    }

    // 临时访问 token
    const domain = window.location.href
    if (getCookie('temp-token') && domain.indexOf('/viewOffer') != -1) {
      config.headers['dhr-Token'] = getCookie('temp-token')
    }
    // 内嵌的 我的简历
    const urlParams = new URLSearchParams(window.location.href)
    if (!(window.self === window.top) && urlParams.get('source') === 'website') {
      config.headers['dhr-Token'] = urlParams.get('dhr-token')
    }
    //logoutMethods();
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// respone拦截器
service.interceptors.response.use(
  async (response) => {
    if (response.config.url === '/api/dhr-account/home/savePageVisit') { 
      if (response.data && response.data.code != 200) { 
        return
      }
    }
    
    deletePending(response)
    if (loadingInstance) loadingInstance.close()
    // console.log('response', response)
    const res = response.data
    if (response.status && response.status !== 200) {
      // 登录超时,重新登录
      if (response.status === 401) {
        window.onbeforeunload = null // 刷新页面不要弹右上角的弹窗
        // 未登录
        // showMessage({
        //   message: res.message || res.msg,
        //   type: 'error',
        //   duration: 5 * 1000
        // })
        // window.localStorage.clear()
        // window.sessionStorage.clear()
        // removeToken('dhr-Token')
        // window.location.href = loginUrl + `?backUrl=${window.location.href}`
        logoutMethods(res.message || res.msg)
      } else {
        showMessage({
          message: res.msg || res.message,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(res || 'error')
    } else {
      if ([401, 444, 8888,403].includes(res.code)) {
        // showMessage({
        //   message: res.message || res.msg,
        //   type: 'error',
        //   duration: 5 * 1000
        // })
        // window.localStorage.clear()
        // window.sessionStorage.clear()
        // removeToken('dhr-Token')
        // window.location.href = loginUrl + `?backUrl=${window.location.href}`
        logoutMethods(res.message || res.msg);
      } else if (['200', '0', 200].includes(String(res.code))) {
        // 处理字段显示取值
        if (response?.config?.url === '/api/zzp-component/component/view/listFields' && res.data && res.data.length) {
          store.commit('fieldList/setListMap', res.data)
        } else if (response?.config?.url === '/api/zzp-component/component/layout/page/layoutAddOrEdit' && res.data && res.data.layoutConfigId) {
          store.dispatch('fieldList/setLimitListMapAction', {
            data: res.data,
            config: response.config.data
          })
        }
        res.__responseConfig__ = response.config
        return Promise.resolve(res)
      } else if (response.request && response.request.responseType === 'blob') {
        let isError = false
        try {
          const obj = await blobToObject(response.data)
          if (obj.code === '500') {
            submitLog(res,response);
            showMessage({
              message: obj.message || obj.msg,
              type: 'error',
              duration: 5 * 1000
            })
            return Promise.reject(obj)
          } else {
            return Promise.resolve(response.data)
          }
        } catch (err) {
          isError = true
        }
        if (isError) {
          return Promise.resolve(response.data)
        }
      } else {
        if (res.code === '600666' || res.code === '600670') {
          return Promise.resolve(res)
        }
        if (res.code === '506') { 
          //跳到封禁页面
          router.push({ path: '/accountBan' })
          return Promise.reject(res)
        }
        if (!['602605', '601105', '600650','601201'].includes(res.code)) {
          submitLog(res,response);
          var regex = /\n/g
          var text = res.message || res.msg
          var message = text.replace(regex, '<br/>')
          let showMsg = true
          if(response.config.url === '/api/zzp-evaluation-train/evaluationRecord/associatedAssessmentList'){
            showMsg = false
          }
          if(showMsg){
            showMessage({
              message: message,
              type: 'error',
              duration: 5 * 1000,
              dangerouslyUseHTMLString: true
            })
          }
        }
        return Promise.reject(res)
      }
    }
  },
  error => {
    deletePending(error)
    if (loadingInstance) loadingInstance.close()
    console.log('err1112: ' + error.message) // for debug
    if (error.response && error.response.status === 401) {
      // showMessage({
      //   message: error.response.data.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      // window.localStorage.clear()
      // window.sessionStorage.clear()
      // removeToken('dhr-Token')
      // window.location.href = loginUrl + `?backUrl=${window.location.href}`
      logoutMethods(error.response.data.message);
    } else {
      // if (error.response.status === 404) return // 未登录不提示
      if (error.response && error.response.status === 402) {
        return Promise.reject(error)
      } // 退出登录不提示
      if (error?.message !== 'cancel request') {
        //submitLog({code:null, msg: '服务器异常'}, error)
        // showMessage({
        //   message: error?.response?.data?.message || '服务器异常',
        //   type: 'error',
        //   duration: 5 * 1000
        // })
      }
      if (error.message.indexOf('timeout') > -1) { 
        submitLog({code:null, msg: '网络超时'}, error)
      }
      return Promise.reject(error)
    }
  }
)

//登陆失效
function logoutMethods(message = '') { 
  // 未登录
  showMessage({
    message,
    type: 'error',
    duration: 5 * 1000
  })
  window.localStorage.clear()
  window.sessionStorage.clear()
  removeToken('dhr-Token')
  //这里的免登必须要判断是在飞书环境里，而不是账号飞书授权
  const flyingBook = /Lark/i.test(navigator.userAgent);
  if (flyingBook) {
    //如果是飞书
    const sourceManageType = '3';//子系统/控制台 枚举
    const hash = window.location.hash.split("?")[1];
    const urlParams = new URLSearchParams(hash);
    const redirectUrl = encodeURIComponent(window.location.href)
    const accountId = urlParams.get('accountId') || urlParams.get('tenantId');
    if (accountId) {
      //如果url中存在租户id，则直接取
      const url = loginUrl + `/share?tcloudId=${accountId}&sourceManageType=${sourceManageType}&redirectUrl=${redirectUrl}`;
      window.location.href = url;
    }
    else { 
      //登陆失效了，就提示重新进入，重新走一遍登录流程
      showMessage({
        message:'登录已失效，请关闭页面重新进入',
        type: 'error',
        duration: 5 * 1000
      })
    }
  }
  else { 
    //不是飞书就按以前的流程走
    window.location.href = loginUrl + `?backUrl=${window.location.href}`
  }

}


export default service
